var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":"2"}},[_c('router-link',{attrs:{"to":{name: 'Project', params:{ 'project_id': _vm.projectEvent._id}}}},[_vm._v(" "+_vm._s(_vm.projectEvent.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }